import {createFileRoute} from '@tanstack/react-router';

import {checklistTemplateKeys} from '@/features/Library/api/queryKeys';
import {getChecklistTemplate} from '@/features/Library/api/readChecklistTemplate';
import {ChecklistTemplateModal} from '@/features/Library/components/ChecklistTemplate/ChecklistTemplateModal';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute(
  '/_b/_p/_library/checklists/$checklistTemplateId'
)({
  component: ChecklistTemplateModal,

  beforeLoad: ({params, context}) => {
    makeDocumentTitle(params.checklistTemplateId);

    return {
      ...context,
      readChecklistTemplateQuery: {
        queryKey: checklistTemplateKeys.detail(params.checklistTemplateId),
        queryFn: () => getChecklistTemplate(params.checklistTemplateId),
      },
    };
  },

  loader({context}) {
    return context.queryClient.ensureQueryData(
      context.readChecklistTemplateQuery
    );
  },
});
